import { render } from "./Management.vue?vue&type=template&id=04b8b706"
import script from "./Management.vue?vue&type=script&lang=ts"
export * from "./Management.vue?vue&type=script&lang=ts"

import "./Management.vue?vue&type=style&index=0&id=04b8b706&lang=scss"
script.render = render

export default script